import {
  CreateCustomSummarySectionRequest,
  CustomSummarySectionEntity,
  GetCustomSummarySectionsParams,
  TServerErrorResponse,
  UpdateCustomSummarySectionRequest,
} from "@/types";
import { links } from "@/constants";
import { http } from "../httpHandler";

export const GET_CUSTOM_SUMMARY_SECTIONS = "get-custom-summary-sections";

export const getCustomSummarySections = async ({
  conversationPurpose,
}: GetCustomSummarySectionsParams = {}) => {
  try {
    const response = await http.get<CustomSummarySectionEntity[]>(
      links.summarizerSettings.customSection,
      {
        params: {
          conversationPurpose,
        },
      },
    );
    return response.data;
  } catch (error) {
    throw error as TServerErrorResponse;
  }
};

export const createCustomSummarySection = async (
  data: CreateCustomSummarySectionRequest,
) => {
  const { conversationPurpose, sectionName, systemPrompt } = data;

  try {
    const response = await http.post<CustomSummarySectionEntity>(
      links.summarizerSettings.customSection,
      {
        conversationPurpose,
        sectionName,
        systemPrompt,
      },
    );
    return response.data;
  } catch (error) {
    throw error as TServerErrorResponse;
  }
};

export const updateCustomSummarySection = async (
  id: string,
  data: UpdateCustomSummarySectionRequest,
) => {
  const { sectionName, systemPrompt } = data;

  try {
    const response = await http.put<CustomSummarySectionEntity>(
      links.summarizerSettings.customSectionById(id),
      {
        sectionName,
        systemPrompt,
      },
    );
    return response.data;
  } catch (error) {
    throw error as TServerErrorResponse;
  }
};

export const deleteCustomSummarySection = async (id: string) => {
  try {
    await http.delete<void>(links.summarizerSettings.customSectionById(id));
  } catch (error) {
    throw error as TServerErrorResponse;
  }
};
